import RecipeTab from './RecipeTab'

export default RecipeTab
